import { NgOptimizedImage } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { CampaignPhase, SubType } from '@shared/constants';
import {
  ElementDirective,
  TooltipDirective,
  TooltipIfTruncatedDirective,
} from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant4Config } from '@shared/models';
import { AmountPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

import { StepBaseClass } from '../step.base.class';

import { ProgressSectionComponent } from './progress-section/progress-section.component';

@Component({
  selector: 'b2c-variant4',
  styleUrl: './variant4.component.scss',
  templateUrl: './variant4.component.html',
  imports: [
    SafePipe,
    AmountPipe,
    NgOptimizedImage,
    ElementDirective,
    WinCardComponent,
    TooltipDirective,
    VariableReplacementPipe,
    ProgressSectionComponent,
    SelectionButtonComponent,
    UnselectionButtonComponent,
    TooltipIfTruncatedDirective,
  ],
})
export class Variant4Component extends StepBaseClass {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant4Config>();
  // Resolved by the parent: sub type designs only apply to bonus campaigns
  subType = input<SubType>(SubType.DEFAULT);

  protected readonly title = computed(
    () =>
      this.challenge().productScope.description[this.shortLocale]?.toString() ??
      ''
  );

  index = input<number>(0);
  loadBannerInPriority = input<boolean>(false);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  withShadow = input<boolean>(true);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
}
